import html from './sizeSelector.module.html';
import css from './sizeSelector.module.css';
import { ControlTemplate } from 'dac-web-ui';

export class SizeSelector extends ControlTemplate {
	constructor() {
		super();
	}

	show( title = 'Confirm', options, selectedOption ) {
		return new Promise(( resolve ) => {
			//CSS
			this._addStyle('sizeSelectorCss', css);

			//template
			var div = document.createElement('div');
			div.innerHTML = html;
			this.element = div.firstChild;
			document.body.appendChild(this.element);

			//select
			let select = this.element.querySelector('.sizeSelectorSelect');
			//add options
			options.forEach(option => {
				let optionElement = document.createElement('option');
				optionElement.value = option;
				optionElement.innerHTML = option;
				if( selectedOption === option ) optionElement.selected = true;
				select.appendChild(optionElement);
			});

			//title
			let titleElement = this.element.querySelector('.sizeSelectorTitle');
			titleElement.innerHTML = typeof title === 'undefined' ? 'alert' : title;

			this._addEvents(resolve);
		});
	}
    
	_addEvents(resolve) {
		//on ok click
		let add = document.querySelector('.sizeSelectorOKButton');
		add.onclick = (e) => this._close(resolve, true);

		//on cancel click
		let remove = document.querySelector('.sizeSelectorCancelButton');
		remove.onclick = (e) => this._close(resolve, false);

		//on close click
		let close = document.querySelector('.sizeSelectorHeaderControls');
		close.onclick = (e) => this._close(resolve, false);

		//escape key
		document.onkeydown = (e) => {
			if (e.key === 'Escape') this._close(resolve, false);
		};
	}

	_close( resolve, ok ) {
		
		let result = null;
		if( ok ) {
			//OK button. Get selected size
			let select = document.querySelector('.sizeSelectorSelect');
			result = select.options[select.selectedIndex].value;
		}

		//on ok click
		let add = document.querySelector('.sizeSelectorOKButton');
		if ( add ) add.onclick = null;

		//on cancel click
		let remove = document.querySelector('.sizeSelectorCancelButton');
		if ( remove ) remove.onclick = null;

		//escape key
		document.onkeydown = null;

		document.body.removeChild(this.element);
		this._removeStyle('sizeSelectorCss');

		if (resolve) resolve( result );
	}
}
